<template>
    <section class="app-container main-top-container">

        <el-form ref="searchForm" :inline="true" :model="searchForm" class="search-bg art-search" :label-position="labelPosition">
            <div>
                <!-- 扩展元素 -->
                <slot name="header-extend" />
            </div>
            <!-- 搜索表单Item -->
            <slot v-if="showSearch" name="search-items" />
            <br>
            <!-- <el-form-item v-if="showSearch">
            <el-button-group>
                <el-button type="primary" @click="handleSearch">查询</el-button>
                <el-button @click="resetSearchForm">重置</el-button>
            </el-button-group>
        </el-form-item> -->
        </el-form>
        <div class="table-title" v-if="showTab">
            <slot name="tab-items" />
        </div>

        <div class="main-table" :style="{paddingBottom:isPage?'0px':'20px'}">
            <slot name="page-title"></slot>
            <el-table ref="table" :height="bHeight != 0?bHeight:''" v-loading="mainData.loading"  :data="mainData.rows" size="mini" element-loading-text="Loading" border fit stripe highlight-current-row @sort-change="sortChange" @selection-change="handleSelectionChange" @row-click="$emit('row-click', $event)">
                <!-- 表格columns -->
                <slot name="table-columns" />
            </el-table>
        </div>


      <template v-if="isPage">
        <pagination :count="mainData.totalPages" :layout="layout" :prevText="prevText" :nextText="nextText" :total-count="mainData.total" :page.sync="mainData.query.pageNo" :limit.sync="mainData.query.pageSize" @pagination="getMainData" @goHome="goHome" v-if="prevText" :key="pageKey"/>
        <pagination :count="mainData.totalPages" :total-count="mainData.total" :page.sync="mainData.query.pageNo" :limit.sync="mainData.query.pageSize" @pagination="getMainData" v-else :key="pageKey+1"/>
        <div class="table-button" v-if="showButton">
          <slot name="tab-buttons" />
        </div>
      </template>
    </section>
</template>

<script>
import pagination from '@/components/pagination/index'
export default {
    name: 'List',
    components: { pagination },
    props: {
        //是否需要默认处理时间
        isNeedTime: { type: Boolean, default: false },
        //是否需要总共条数
        isNeedTotle: { type: Boolean, default: false },
        //是否本地排序
        isBaseSort: { type: Boolean, default: false },
        //针对输入框默认值--秒杀
        isDefaultTime: { type: Boolean, default: false },
        //是否展示上一页下一页
        prevText: { type: String, default: '' },
        nextText: { type: String, default: '' },
        layout: { type: String, default: 'total, sizes, prev, pager, next, jumper' },
        isCheck: { type: Boolean, default: false },
        //table高度
        height: { type: Number, default: 0 },
        //是否显示底部button
        showButton: { type: Boolean, default: false },
        //是否显示tab
        showTab: { type: Boolean, default: false },
        labelPosition: { type: String, default: 'right' },
        // 搜索表单
        searchForm: { type: Object, default: Object },
        // 重置参数之前需要调整的默认参数
        beforeResetForm: { type: Function, default: Function },
        // 是否显示搜索栏
        showSearch: { type: Boolean, default: true },
        // 搜索表单的 LabelWidth
        searchLabelWidth: { type: String, default: '' },
        // 请求列表方法
        fetchListFunc: { type: Function, default: Function },
        // 删除方法
        deleteRowFunc: { type: Function, default: Function },
        // 修改请求回来的数据, 需要返回Item
        mainDataEachCallbackFunc: { type: [Function, Boolean], default: false },
        // 自动请求数据
        autoFetch: { type: Boolean, default: true },
        // 是否分页
        isPage: { type: Boolean, default: true },
        // 是否在渲染的时候获取列表数据
        isInitList: { type: Boolean, default: true },
    },
    data() {
        return {
            // 默认表单(方便以后重置)
            defaultSearchForm: {},
            mainData: {
                loading: false,
                rows: [],
                totalPages: 0,
                total: 0,
                query: {
                    pageNo: 1,
                    pageSize: 10,
                    nextToken: this.prevText ? '' : void 0
                }
            },
            bHeight: void 0,
            pageKey:0
        }
    },
    activated() {
        this.isInitList&&this.autoFetch && this.getMainData()
        // 回车搜索
        this.handleSearchByEnter = e => {
            if (e.keyCode === 13) this.handleSearch()
        }
    },
    created() {
        // 保存搜索默认值,
        this.defaultSearchForm = { ...this.searchForm }
    },

    mounted() {
        if (this.height && this.height != 0) this.bHeight = this.height;
        window.document.body.addEventListener(
            'keydown',
            this.handleSearchByEnter,
            false
        )



    },
    beforeDestroy() {
        window.document.body.removeEventListener(
            'keydown',
            this.handleSearchByEnter
        )
    },
    methods: {
        toggleRowSelection(row) {
            this.$refs.table.toggleRowSelection(row);
        },
        /**
         * 获取数据
         * 请求时会带上 searchForm 数据
         */
        getMainData(param) {
            let that = this
            that.mainData.loading = true
            const { query } = that.mainData
            let searchForm
            // if(this.currentPage < query.pageNo)this.$store.dispatch('toggleCurrentPage',query.pageNo)
            //   else query.pageNo=this.currentPage;
            if (param && typeof param == 'string')
                searchForm = that.defaultSearchForm || {}
            else {
                searchForm = that.searchForm || {}
            }
            // 时间单独处理
            if (!that.isNeedTime) {
                if (searchForm.Time) {
                    searchForm = { ...that.searchForm }
                    searchForm.Time = searchForm.Time.join('~')
                }
                if (searchForm.time) {
                    searchForm = { ...that.searchForm }
                    searchForm.time = searchForm.time.join('~')
                }
            }

            // let filters,filter=this.$route.query;
            // let arr = Object.keys(filter);
            // if(!param) filters=Object.assign(searchForm,query);
            // else {
            //   if(typeof param == 'string')
            //   {
            //     debugger;
            //     if(arr.length == 0)  filters=query;
            //     else filters=Object.assign(query,filter);
            //   }else filters=Object.assign(searchForm,query);
            // }
            searchForm = Object.assign(searchForm, query)

            const pr = that.fetchListFunc(searchForm)
            if (pr && pr.then) {
                pr.then(response => {
                    if (that.mainDataEachCallbackFunc) {
                        response.data.data.map(that.mainDataEachCallbackFunc)
                    }
                    if (response.data) {
                        if (that.isDefaultTime) {
                            for (var i = 0; i < response.data.data.length; i++) {
                                response.data.data[i].appMins = ['10:00', '23:59'];
                                response.data.data[i].areaId = ['42d06f90-15a3-4126-a073-33c52547342f']
                            }
                        }
                        that.mainData.rows = response.data.data
                        that.mainData.totalPages = response.data.pages
                        that.mainData.total = response.data.totalCount
                        if (that.nextText) that.mainData.query.nextToken = response.data.ext;
                        if (that.isNeedTotle) that.$emit('needPages', response.data.totalCount)
                    } else {
                        that.mainData.rows = []
                        that.mainData.totalPages = 0
                        that.mainData.total = 0
                    }
                    this.$forceUpdate()
                    that.mainData.loading = false
                    that.$emit('onPageChange',{page:that.mainData.query.pageNo,size:that.mainData.query.pageSize})
                }).catch(e => {
                    console.error('get main data', e)
                    that.mainData.loading = false
                })
            } else {
                console.warn('fetch-list-func 必须为 promise')
            }
        },
        /**
         * 所搜方法
         * 会将页码重置为 1
         */
        handleSearch() {
            this.mainData.query.pageNo = 1;
            if (this.nextText) this.mainData.query.nextToken = "";
            // this.mainData.query.pageNoIndex = 1
            this.getMainData()
            return false
        },
        handleSearchs() {
            this.getMainData()
            return false
        },
        handleSearchByPage(page,size){
            this.mainData.query.pageSize = size;
            this.mainData.query.pageNo = page;
            this.pageKey+=1;
            this.getMainData()
            return false
        },
        goHome(param) {
            this.mainData.query.pageNo = param.page;
            this.mainData.query.pageSize = param.limit;
            this.getMainData(param)
        },
        setValue(index, row) {
            this.$set(this.mainData.rows, index, row)
        },
        /**
         * 重置表单
         * url带参数(typeId || id || userId || title) 会重置为无参数链接
         */
        resetSearchForm() {
            const { typeId, id, userId, title } = this.$route.query
            if (typeId || id || userId || title) {
                this.$router.replace(this.$route.path)
                return
            }
            this.$refs.searchForm.resetFields()
            let param = { page: 1, limit: 10 }
            //this.defaultSearchForm={page:1,limit:10};
            this.defaultSearchForm = this.judge(this.defaultSearchForm) //参数置空
            this.defaultSearchForm = Object.assign(this.defaultSearchForm, param)
            //this.beforeResetForm(this.defaultSearchForm);
            this.mainData.query.pageNo = 1
            this.mainData.query.pageSize = 10
            this.$emit('update:search-form', { ...this.defaultSearchForm })
            this.getMainData('clear')
        },

        /**
         * 设置行数据
         * @param idx
         * @param newVal
         */
        setRowValue(idx, newVal) {
            let row = this.mainData.rows[idx]
            if (row) {
                row = Object.assign(row, newVal)
            } else {
                this.$logger.error('row value', row)
            }
        },

        /**
         * 获取行数据
         * @param idx
         * @returns {*}
         */
        getRowValue(idx) {
            return this.mainData.rows[idx]
        },

        /**
         * 删除弹窗
         * @param deleteFunc
         * @param txt
         * @returns {Promise<any>}
         */
        deleteConfirm(deleteFunc, txt = '是否删除？') {
            return new Promise((resolve, reject) => {
                this.$alert(txt, '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    confirmButtonClass:'confirmBtn',
                    showCancelButton: true,
                    type: 'warning'
                })
                    .then(deleteFunc)
                    .then(() => {
                        resolve()
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        })
                        this.getMainData()
                    })
                    .catch(() => {
                        reject()
                    })
            })
        },

        /**
         * 修改排序
         * @param order
         * @param prop
         */

        sortChange(column) {
            if (this.isBaseSort) this.searchForm.orderBy = this.getOrderParams(column.order, column.prop)
            else this.searchForm.sortBy = this.getOrderParams(column.order, column.prop)
            this.getMainData()
        },

        /**
         * 获取修改排序参数
         * @param order
         * @param prop
         * @returns {string}
         */
        getOrderParams(order, prop) {
            if (!order || !prop) return ''
            let rule
            if (order === 'ascending') {
                rule = 'asc'
            } else if (order === 'descending') {
                rule = 'desc'
            }
            if (this.isBaseSort) return prop.replace(prop[0], prop[0].toUpperCase()) + " " + rule;
            else return prop.replace(prop[0], prop[0]) + ' ' + rule
        },
        judge(NumOrString) {
            let param = NumOrString
            for (var key in NumOrString) {
                if ((NumOrString[key] && NumOrString[key] != '') || !NumOrString[key]) {

                    if (this.$route.path != '/content/interaction/list') {

                        if (this.$route.path == '/content/question/problem/list' || this.$route.path == '/content/question/answer/list') {
                            if (!this.$route.query.isReplySource) {
                                if (key == 'createStartTime' && NumOrString[key] == '') param[key] = this.getCurrentTimefunction(1)
                                if (key == 'createEndTime' && NumOrString[key] == '') param[key] = this.getCurrentTimefunction()
                            } else param[key] = ''
                            if (key != 'createStartTime' && key != 'createEndTime') param[key] = ''
                        }
                    } else {
                        if (key == 'commentType') param[key] = 0
                        if (key == 'parentId') param[key] = ''
                    }

                } else {
                    param[key] = NumOrString[key]
                }
            }
            return param
        },
        getCurrentTimefunction(param) {
            var time = new Date();
            if (param) {
                time.setMonth(time.getMonth() - 1);
                return time.getFullYear() + "-" + (time.getMonth() + 1) + "-1 " + "00:00:00";
            }
            return time.getFullYear() + "-" + (time.getMonth() + 1) + "-" + time.getDate() + " " + time.getHours() + ":" + time.getMinutes() + ":" + time.getSeconds()
        },

        handleSelectionChange(val) {
            if (!this.isCheck) {
                let arr = [];
                val.map((item) => {
                    arr.push(item.id);
                })
                this.$emit('update:selection', arr);
            } else {
                this.$emit('update:selection', val);
            }
        },
        handleClearSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.table.toggleRowSelection(row);
                });
            } else {
                this.$refs.table.clearSelection();
            }
        }
    }
}
</script>

<style scoped lang="less">
.table-button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.table-title {
  padding: 10px 20px;
  background: #fff;
  border-radius: 8px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.table-title ~ .main-table {
  border-radius: 8px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.main-table {
  padding: 24px;
  padding-bottom: 0;
  border-radius: 8px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background: #fff;


}


.page-tabe-title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 23px;
}
.page-tabe-title .right{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 18px;
}
.page-tabe-title .right .line{
    width: 4px;
    height: 16px;
    background: #3572e2;
    margin-right: 12px;
}

.page-tabe-title .left .add-btn{
    width: 104px;
    height: 36px;
    background: #3572e2;
    border-radius: 2px;
    color: #fff;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
}

/deep/.art-search {
  overflow: hidden;
  .el-input{
    width: 180px !important;
  }
  .el-select{
    width: 180px !important;
  }
}
</style>
